export const formatImc = (imc: number): string => {
  const parsedImc = parseFloat(imc?.toString() ?? '').toFixed(1)
  if (imc < 10) {
    return `0${parsedImc}`
  }
  return parsedImc
}
